import FormUIOptions from '../components/formBuilder/formElements/formUIOptions';
import { isValue } from '../utility/isValue';

export default {
  calculations: {
    schema: [
      {
        sectionType: 'comparison',
        sectionLabel: '',
        sectionValue: 'cash-flow-comparison',
        //for now u gotta put three schemas
        schemas: [
          {
            sectionLabel: '',
            // sectionSubLabel: 'Monthly',
            annualValue: true,
            afterValues: true,
            schema: [
              {
                type: FormUIOptions.Money,
                label: 'Gross Rent',
                name: 'totalRentalIncome',
                tooltipHeading: 'Gross Rent',
                description: 'Rental income across all units',
                unit: '$',
              },
              {
                type: FormUIOptions.Table,
                label: '',
                name: 'grossIncomePerUnit',
                condition: [
                  {
                    field: 'enterTotalRentalIncome',
                    value: false,
                  },
                ],
                schema: [
                  {
                    type: FormUIOptions.Text,
                    name: 'unitName',
                    label: 'Unit Name',
                    derivedFrom: ['unitName'],
                    calFunction: (name) => {
                      return `Unit ${name}`;
                    },
                  },
                  {
                    type: FormUIOptions.UnitMoney,
                    label: '',
                    showMonthly: true,
                    unit: '$',
                    isConstant: true,
                    displayMonthlyFrom: ['rent'],
                    displayMonthlyFunction: (rent) => {
                      return rent;
                    },
                  },
                ],
              },
              {
                type: FormUIOptions.Money,
                label: 'Vacancy',
                layout: 'default',
                name: 'vacancy',
                unit: '$',
                formula: (vacancy) => ['-', `${vacancy}`],
                displayPercentFrom: [
                  'vacancyDeduction',
                  'totalRentalIncomeOnPurchase',
                ],
                displayPercentFunction: (
                  vacancyDeduction,
                  totalRentalIncome
                ) => {
                  if (isValue(vacancyDeduction) && isValue(totalRentalIncome)) {
                    return Math.round(
                      (vacancyDeduction / totalRentalIncome) * 100
                    );
                  } else {
                    return null;
                  }
                },
              },
              {
                type: FormUIOptions.Money,
                label: 'Other Income',
                name: 'totalOtherIncome',
                groupEnd: true,
                tooltipHeading: 'Additional Income',
                description:
                  'Additional income except for rent across all units',
                unit: '$',
                formula: (totalAdditionalIncome) => [
                  '+',
                  `${totalAdditionalIncome}`,
                ],
              },
              {
                type: FormUIOptions.Table,
                label: '',
                name: 'otherPropertyIncome',
                condition: [
                  {
                    field: 'cashPurchase',
                    value: false,
                  },
                  {
                    field: 'enterTotalOtherIncome',
                    value: [false, undefined, ''],
                  },
                ],
                schema: [
                  {
                    type: FormUIOptions.Text,
                    name: 'otherIncomeName',
                    label: 'Other Income',
                    small: true,
                  },
                  {
                    type: FormUIOptions.UnitMoney,
                    label: 'Amount',
                    layout: 'default',
                    name: 'otherIncomeAmount',
                    unit: '$',
                    small: true,
                  },
                ],
              },
              {
                type: FormUIOptions.Money,
                label: 'Gross Income',
                name: 'monthlyGOI',
                emphasize: true,
                groupStart: true,
                tooltipHeading: 'Gross Income (GOI)',
                description:
                  'Rental income across all units adjusted for vacancy rate',
                unit: '$',
                formula: (monthlyGOI) => ['=', `${monthlyGOI}`],
                total: true,
              },
              {
                type: FormUIOptions.Money,
                label: 'Expenses',
                layout: 'default',
                name: 'totalMonthlyOperatingExpenses',
                groupEnd: true,
                unit: '$',
                formula: (totalMonthlyOperatingExpensesPurchase) => [
                  '-',
                  `${totalMonthlyOperatingExpensesPurchase}`,
                ],
              },
              {
                type: FormUIOptions.Table,
                label: '',
                name: 'operatingExpenses',
                condition: [
                  {
                    field: 'cashPurchase',
                    value: false,
                  },
                  {
                    field: 'enterTotalExpenses',
                    value: [false, undefined, ''],
                  },
                ],
                schema: [
                  {
                    type: FormUIOptions.Text,
                    name: 'expenseName',
                    label: 'Expense',
                    small: true,
                  },
                  {
                    type: FormUIOptions.UnitMoney,
                    derivedFrom: 'rentalIncomePreVacancy',
                    label: 'Amount',
                    layout: 'default',
                    name: 'expenseAmount',
                    unit: '$',
                    small: true,
                  },
                ],
              },
              {
                type: FormUIOptions.Money,
                label: 'Net Income',
                layout: 'default',
                name: 'netMonthlyIncome',
                groupStart: true,
                emphasize: true,
                tooltipHeading: 'Net Income (NOI)',
                description:
                  'Income from all units adjusted for total operating expenses',
                unit: '$',
                formula: (monthlyNOI) => ['=', `${monthlyNOI}`],
                total: true,
              },
              {
                type: FormUIOptions.Money,
                label: 'Loan Payment',
                name: 'newMonthlyPaymentWithRehab',
                unit: '$',
                formula: (monthlyDebtService) => ['-', `${monthlyDebtService}`],
              },
              {
                type: FormUIOptions.Money,
                label: 'Cash Flow',
                layout: 'default',
                name: 'newMonthlyPreTaxCashFlow',
                emphasize: true,
                dynamic: true,
                unit: '$',
                formula: (annualPreTaxCashFlow) => [
                  '=',
                  `${annualPreTaxCashFlow}`,
                ],
              },
            ],
          },
        ],
      },
    ],
  },
};
